import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { TranslationService } from '@sdbn/common';
import { ArticleType } from 'src/erp-articles/article-types/article-type.model';
import { ArticleTypeService } from 'src/erp-articles/article-types/article-type.service';
import { AddCatalogDialogComponent } from '../add-catalog-dialog/add-catalog-dialog.component';

@Component({
  selector: 'app-add-article-type-selection',
  templateUrl: './add-article-type-selection.component.html',
  styleUrls: ['./add-article-type-selection.component.scss']
})
export class AddArticleTypeSelectionComponent implements OnInit {

  selected: ArticleType;

  constructor(
    public translationService: TranslationService,
    public dialogRef: MatDialogRef<AddCatalogDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public articleTypeService: ArticleTypeService
  ) {


    // ...



  }

  ngOnInit(): void {
  }

  onClose() {
    this.dialogRef.close();
  }

  onConfirm() {
    this.dialogRef.close(this.selected);
  }

  selectArticleType(articleType: ArticleType) {
    this.selected = articleType;
  }

}
